<template>
    <ais-range-input
      :attribute="attributeName"
      :class-names="{'ais-RangeInput': 'ml-6 mr-10 md:mx-6'}"
    >
      <div slot-scope="{ currentRefinement, range, refine }">
        <vue-slider
          :min="range.min"
          :max="range.max"
          :contained="true"
          tooltip-placement="bottom"
          tooltip="always"
          :lazy="true"
          :silent="true"
          :tooltip-formatter="formatRangeSliderTooltip"
          :value="toValue(currentRefinement, range)"
          @change="refine({ min: $event[0], max: $event[1] })"
        />
      </div>
    </ais-range-input>
</template>

<script>
import VueSlider from 'vue-slider-component';

export default {
  components: {
    VueSlider,
  },
  props: {
    attributeName: {
      type: String,
      required: true,
    },
  },

  data() {
    return {};
  },
  methods: {
    formatRangeSliderTooltip (value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return formatter.format(value);  
    },
    toValue(value, range) {
      return [
        (value.min !== null && value.min != undefined) ? value.min : range.min,
        (value.max !== null && value.max != undefined) ? value.max : range.max,
      ];
    },
  },
};
</script>

<style lang="scss">
  $themeColor: rgba(6, 182, 212, 1);
  $tooltipFontSize: 0.65rem;
  $tooltipBorderRadius: 0.65rem;
  $labelFontSize: 0.65rem;
  $tooltipPadding: 3px 7px;
  @import '~vue-slider-component/lib/theme/default.scss';
</style>
